import styled from "styled-components";

// Static decoration sits in the surrounding frame, never over the artwork.
const ArtworkAtmosphere = styled.div`
  position: relative;
  min-width: 0;
  padding: clamp(12px, 2vw, 24px);
  background-color: ${p => p.theme.colors.homeNavy};
  background-image:
    radial-gradient(circle at 4% 18%, rgba(228, 237, 241, .8) 0 1px, transparent 2px),
    radial-gradient(circle at 96% 33%, rgba(127, 205, 205, .8) 0 1px, transparent 2px),
    radial-gradient(circle at 22% 3%, rgba(228, 194, 140, .7) 0 1px, transparent 2px),
    radial-gradient(circle at 72% 97%, rgba(228, 237, 241, .7) 0 1px, transparent 2px),
    radial-gradient(circle at 3% 76%, rgba(127, 205, 205, .55) 0 .7px, transparent 1.5px),
    radial-gradient(circle at 98% 88%, rgba(228, 237, 241, .6) 0 .7px, transparent 1.5px),
    radial-gradient(ellipse at 0% 30%, rgba(38, 124, 132, .42), transparent 58%),
    radial-gradient(ellipse at 100% 75%, rgba(29, 96, 127, .4), transparent 58%);
  box-shadow: 0 0 24px rgba(29, 96, 127, .13);
`;

export default ArtworkAtmosphere;
